import { render, staticRenderFns } from "./MsgIcon.vue?vue&type=template&id=c49ad1b6"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c49ad1b6')) {
      api.createRecord('c49ad1b6', component.options)
    } else {
      api.reload('c49ad1b6', component.options)
    }
    module.hot.accept("./MsgIcon.vue?vue&type=template&id=c49ad1b6", function () {
      api.rerender('c49ad1b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/MsgIcon.vue"
export default component.exports